module.exports = __webpack_public_path__ + "logogr.png?8a7292f85786e273dc68dfc780abb497";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logogr.png
// module id = 21
// module chunks = 0